import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';

const Contacto = ({ temaActual }) => {
  const { t } = useTranslation();
  const datosContacto = [
    { icon: MapPin, text: t('contact.address') },
    { icon: Phone, text: t('contact.phone') },
    { icon: Mail, text: t('contact.email') },
    { icon: Clock, text: t('contact.hours') }
  ];

  return (
    <section id="contacto" className="bg-gray-900 px-4 py-12 text-white">
      <div className="container mx-auto">
        <div className="grid gap-8 md:grid-cols-2">
          <div>
            <h2 className="mb-6 text-2xl font-bold">{t('contact.title')}</h2>
            <div className="space-y-4">
              {datosContacto.map((item) => (
                <div key={item.text} className="flex items-center gap-4 rounded-lg bg-white/10 p-3 backdrop-blur-sm transition-all hover:bg-white/20">
                  <item.icon className="h-5 w-5 text-blue-400" />
                  <span className="text-sm">{item.text}</span>
                </div>
              ))}
            </div>
            <button className={`mt-6 rounded-lg bg-gradient-to-r ${temaActual.gradient} px-6 py-3 text-sm font-semibold shadow-lg transition-all hover:shadow-xl`}>
              {t('contact.button')}
            </button>
          </div>

          <div className="rounded-2xl bg-gray-800 p-4">
            <h3 className="mb-3 text-xl font-bold">{t('contact.location')}</h3>
            <div className="h-[250px] overflow-hidden rounded-xl bg-gray-700">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d18734.477352175727!2d-60.58347347129596!3d-33.89431523855412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b84aad3ef60a31%3A0x481ac3277962e9c5!2sPergamino%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1787086740457!5m2!1ses-419!2sar"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={t('contact.mapTitle')}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacto;
